<div
    bsModal
    #selectBranchModal="bs-modal"
    class="modal right fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div
        class="modal-dialog right-modal"
        [ngClass]="active ? 'slide-right-in' : 'slide-right-out'"
        role="document"
    >
        <div class="modal-content">

            <div class="modal-content-wrapper" *ngIf="active"  >
                <div class="modal-header">
                    <h4 class="modal-title" >
                        <span>{{l("SelectBranch")}}</span>
                        <p class="desc-menu-item">{{l("SelectFromTheBelowBranches")}}</p>
                    </h4>
                    <button style="position: absolute;right: 0;top: 8px;" type="button" class="close" (click)="close()" aria-label="Close" [disabled]="saving">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body p-0 thin-scroll mr-2">
                    <p class="title-tree ml-3">{{l("ProductType")}}</p>
                    <p-tree [value]="filteredbranches" selectionMode="single" [filter]="true" [(selection)]="selectedBranch" (onNodeExpand)="getBranches($event)"  [loading]="loading">
                    </p-tree>

                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default btn-gray" (click)="close()">{{l("Cancel")}}</button>
                    <button type="submit" (click)="selectBranch()" class="btn btn-primary blue btn-blue" [disabled]="!selectedBranch" [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')"> <span>{{l("select")}}</span></button>
                </div>
            </div>
        </div>
    </div>
</div>





